import comp from "./TagPracticesV2";
export default comp;
